import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.number.constructor";
import vipComputedMixin from '@/mixin/computed/vip';
import BaseItem from '@/components/item/BaseItem/BaseItem.vue';
import Icon from '@/components/base/Icon/Icon.vue';

// client js begin
import { bookActivity, bookActivityNew } from '@/services/bookService';
// client js end

function pad0(i) {
  return (i + '').length < 2 ? '0' + i : i;
}
var _StateDefine = {
  Ordering: 'Ordering',
  InProgress: 'InProgress',
  Ended: 'Ended'
};
var _ActLabel = {
  ActLabel_New: 1,
  ActLabel_Hot: 2
};
export default {
  mixins: [vipComputedMixin],
  props: {
    item: {
      required: true,
      type: Object
    },
    isOnlyOne: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      second: '00',
      minute: '00',
      hour: '00',
      day: '0',
      asyncBookStatus: false,
      showAskFollowModal: false
    };
  },
  components: {
    BaseItem: BaseItem,
    Icon: Icon
  },
  computed: {
    isBook: function isBook() {
      return this.item.tActState.iBookStatus;
    },
    ActLabel: function ActLabel() {
      return _ActLabel;
    },
    isHot: function isHot() {
      return this.item.tActState.iActLabel === _ActLabel.ActLabel_Hot;
    },
    StateDefine: function StateDefine() {
      return _StateDefine;
    },
    state: function state() {
      var now = this.$store.state.nowTimestamp;
      var state;
      if (now > this.endTimestamp) {
        state = _StateDefine.Ended;
      } else if (now > this.startTimestamp) {
        state = _StateDefine.InProgress;
      } else {
        state = _StateDefine.Ordering;
      }
      var start = state === _StateDefine.Ordering ? this.startTimestamp : this.endTimestamp;
      var diff = start - now;
      /* eslint-disable */
      this.second = pad0(diff % 60);
      this.minute = pad0(parseInt(diff % 3600 / 60));
      this.hour = pad0(parseInt(diff % 86400 / 3600));
      this.day = parseInt(diff / 86400);
      /* eslint-enable */
      return state;
    },
    startTimestamp: function startTimestamp() {
      return this.item.tActState.lStartTimestamp;
    },
    endTimestamp: function endTimestamp() {
      return this.item.tActState.lEndTimeStamp;
    },
    booked: function booked() {
      return this.isBook || this.asyncBookStatus;
    },
    reportStatus: function reportStatus() {
      if (this.state === _StateDefine.Ordering && !this.booked) {
        return '预约';
      } else if (this.state === _StateDefine.InProgress) {
        return '马上抢';
      } else {
        return '已结束';
      }
    },
    // 数据上报参数，内部使用
    posterParams: function posterParams() {
      var _this$item = this.item,
        title = _this$item.sTitle,
        cubeId = _this$item.sActID;
      return {
        f_module: '限时秒杀',
        f_resource: title + this.reportStatus,
        f_type: 4,
        f_cubeid: cubeId,
        eid: 'poster',
        item_idx: this.index,
        content_id: title,
        rtype: 'h5',
        poster_type: 'up_pic_down_text_vertical'
      };
    }
  },
  filters: {
    pic: function pic(item, picSize) {
      return item.tPicList.mpList['pic_' + picSize];
    }
  },
  methods: {
    clickItem: function () {
      var _clickItem = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(place) {
        var judge;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(place === 'outer' && !this.booked)) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                _context.prev = 2;
                _context.next = 5;
                return this.checkVipStatus();
              case 5:
                judge = _context.sent;
                if (judge) {
                  _context.next = 8;
                  break;
                }
                return _context.abrupt("return");
              case 8:
                if (this.state === _StateDefine.Ordering && !this.booked) {
                  this.order();
                } else if (this.state === _StateDefine.Ordering && this.booked) {
                  // this.toast('已预约，活动开始前将会消息通知您')
                  this.openH5();
                } else {
                  this.openH5();
                }
                _context.next = 14;
                break;
              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](2);
                console.log('预约报错', _context.t0);
              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 11]]);
      }));
      function clickItem(_x) {
        return _clickItem.apply(this, arguments);
      }
      return clickItem;
    }(),
    openH5: function openH5() {
      if (this.item && this.item.tActType.sActType !== 'welfare') {
        this.openUrl(this.item.tActType.sH5Url);
      }
    },
    order: function () {
      var _order = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _ref, _ref$actID, actId, _ref$modID, modId, result, ret, msg, _result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.booked) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return");
              case 2:
                _ref = this.item.mpExpansion || {}, _ref$actID = _ref.actID, actId = _ref$actID === void 0 ? '' : _ref$actID, _ref$modID = _ref.modID, modId = _ref$modID === void 0 ? '' : _ref$modID;
                if (!(actId && modId)) {
                  _context2.next = 18;
                  break;
                }
                _context2.prev = 4;
                _context2.next = 7;
                return bookActivityNew(actId, modId);
              case 7:
                result = _context2.sent;
                ret = result.ret, msg = result.msg;
                if (ret === 0) {
                  this.asyncBookStatus = 1;
                  this.$emit('order', {
                    actId: actId
                  });
                } else {
                  this.toast("\u9884\u7EA6\u5931\u8D25".concat(msg || ''));
                }
                _context2.next = 16;
                break;
              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](4);
                this.toast('预约失败');
                console.log('新版预约失败。。。。。', _context2.t0);
              case 16:
                _context2.next = 28;
                break;
              case 18:
                _context2.prev = 18;
                _context2.next = 21;
                return bookActivity(this.item.sActID);
              case 21:
                _result = _context2.sent;
                if (_result.list[0].book_ret === 0 && _result.list[0].is_book === 1) {
                  this.asyncBookStatus = 1;
                  this.$emit('order', {
                    actId: this.item.sActID
                  });
                } else {
                  this.toast('预约失败');
                }
                _context2.next = 28;
                break;
              case 25:
                _context2.prev = 25;
                _context2.t1 = _context2["catch"](18);
                this.toast('预约失败');
              case 28:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 12], [18, 25]]);
      }));
      function order() {
        return _order.apply(this, arguments);
      }
      return order;
    }(),
    end: function end(event) {
      event.stopPropagation();
      this.toast('活动已结束');
    }
  },
  reportData: {
    '预约': function 预约(p) {
      return p;
    },
    '马上抢': function 马上抢(p) {
      return p;
    },
    '已结束': function 已结束(p) {
      return p;
    }
  }
};